export const options = [
  { label: 'Central Time (US&Canada)', value: 'US/Central' },
  { label: 'Atlantic Time (US&Canada)', value: 'SystemV/AST4ADT' },
  { label: 'Eastern Time (US&Canada)', value: 'US/Eastern' },
  { label: 'Mountain Time (US&Canada)', value: 'US/Mountain' },
  { label: 'Indiana (East)', value: 'America/Indianapolis' },
  { label: 'Saskatchewan', value: 'Canada/Saskatchewan' },
  { label: 'Arizona', value: 'US/Arizona' },
  { label: 'Pacific Time (US&Canada)', value: 'US/Pacific' },
  { label: 'Alaska', value: 'US/Alaska' },
];
